const STORAGE_KEY = 'recentViewedContracts';
const MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000; // 3일
const MAX_ITEMS = 50;

export const getRecentViewed = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    // 만료 제거 및 정렬(최근순)
    const filtered = arr
      .filter((item) => item && item.viewedAt && now - item.viewedAt <= MAX_AGE_MS)
      .sort((a, b) => b.viewedAt - a.viewedAt);
    // 저장소 정리
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_ITEMS)));
    return filtered;
  } catch (_) {
    return [];
  }
};

export const addRecentViewed = (contractId, memberNumber, deceasedName) => {
  try {
    const now = Date.now();
    const prev = getRecentViewed();
    // 동일 계약 제거 후 맨 앞 삽입
    const deduped = prev.filter((x) => x.id !== contractId);
    deduped.unshift({ id: contractId, memberNumber: memberNumber || '', deceasedName: deceasedName || '', viewedAt: now });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(deduped.slice(0, MAX_ITEMS)));
  } catch (_) {}
};

export const clearRecentViewed = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {}
};


